import { forwardRef, FunctionComponent } from 'react'
import styled, { useTheme, css } from 'styled-components'
import SvgIcon from '../../SvgIcon'
import { NavigationButtonProps } from './index'
import classNames from '../classNames'
import ButtonWrapper from './ButtonWrapper'
import ButtonCircle from './ButtonCircle'
import { useFullScreenGallery } from '@hooks/useFullScreenGallery'

const NextButtonWrapper = styled(ButtonWrapper)`
  right: 0;
`

const NextButton = styled.div<{ isInGallery: boolean }>`
  ${({ isInGallery }) => css`
    ${isInGallery &&
    css`
      right: 0;
    `}

    &:after {
      content: '';
    }

    ${!isInGallery &&
    css`
      padding-right: 24px;
    `}
  `}
`

const NextButtonSVGIcon = styled(SvgIcon)<{ isInGallery: boolean }>`
  ${({ isInGallery }) => css`
    ${isInGallery &&
    css`
      background: ${({ theme }) => theme.colors.brandColors.brand_55};
    `}
  `}
`

const NavigationButtonNext: FunctionComponent<NavigationButtonProps> =
  forwardRef((props, ref) => {
    const theme = useTheme()
    const { isGalleryWidget, hideFullScreenGalleryControls } =
      useFullScreenGallery()

    if (hideFullScreenGalleryControls) {
      return null
    }

    return (
      <NextButtonWrapper ref={ref} onClick={props?.onClick}>
        <NextButton
          className={classNames.navigationButtonNext}
          isInGallery={!!isGalleryWidget}>
          {!isGalleryWidget && <ButtonCircle />}
          <NextButtonSVGIcon
            iconName="gallery-next"
            size={26}
            color={theme.colors.white}
            isInGallery={!!isGalleryWidget}
          />
        </NextButton>
      </NextButtonWrapper>
    )
  })

NavigationButtonNext.displayName = 'NavigationButtonNext'

export default NavigationButtonNext
